import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowRight } from 'lucide-react';
import { Breadcrumb } from '../initiatives/Breadcrumb';
import { StatusBadge } from '../initiatives/StatusBadge';
import { easeOutStrong } from '../../utils/motion';
const focusRing = 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal';
export function CognocracyHero() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-167" data-mp="1o0644ary39wo">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: easeOutStrong
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168" data-mp="1s1hljt0o0ots">
        <Breadcrumb items={[{
        label: 'Home',
        href: '/'
      }, {
        label: 'Projects',
        href: '/projects'
      }, {
        label: 'Cognocracy'
      }]} data-id="element-169" data-mp="21zxg65ywig81" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-170" data-mp="3dc7zzmvo320c">
          <div className="lg:col-span-5" data-id="element-171" data-mp="1t3m7sgxxjl22">
            <div className="flex flex-wrap items-center gap-3 mb-5" data-id="element-172" data-mp="1t2jddz1ef0he">
              <p className="text-sm font-medium text-teal" data-id="element-173" data-mp="1p3k2zywwebik">Civic Governance Project</p>
              <StatusBadge data-id="element-174" data-mp="1k2wat9wxnomr">Concept Proposal</StatusBadge>
            </div>
            <h1 className="font-heading font-extrabold text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-175" data-mp="1f5e1vjix19er">
              Cognocracy
            </h1>
            <p className="mt-5 font-heading font-semibold text-xl lg:text-2xl text-navy leading-snug" data-id="element-176" data-mp="1a7vzyd3bfug9">
              Developing Human Capability. Advancing Civic Judgment.
            </p>
          </div>
          <div className="lg:col-span-7 lg:pt-12" data-id="element-177" data-mp="11b3jrl1fcdho">
            <p className="text-xl lg:text-2xl text-ink-dark leading-relaxed" data-id="element-178" data-mp="wffu74j15ibn">
              Cognocracy is a proposed civic framework powered by SyNeural. It
              explores how structured assessment, continuous capability
              development, and verified credentials could support institutional
              trust, leadership selection, and readiness for public
              responsibility.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-179" data-mp="ht8zinpiaros">
              <a href="/projects/cognocracy#framework" className={`inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap ${focusRing}`} data-id="element-180" data-mp="3sofxpbroru8">
                Explore the Framework
                <ArrowDown size={18} aria-hidden="true" data-id="element-181" data-mp="10k9znf2d4t9x" />
              </a>
              <a href="/human-capability" className={`inline-flex items-center justify-center gap-2 border border-line text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap ${focusRing}`} data-id="element-182" data-mp="mpzipjwly3ef">
                View the Human Capability Framework
                <ArrowRight size={18} aria-hidden="true" data-id="element-183" data-mp="33ysr6kc63ab5" />
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}